module.exports = __webpack_public_path__ + "img/p.9b8965d2.png";